import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, lastValueFrom } from 'rxjs';
import { AuthService } from './auth.service';
import { environment } from '../../../environments/environment';

/**
 * Interceptor funcional que adjunta el Bearer token a las peticiones HTTP
 * dirigidas a la API y gestiona la renovación transparente del token.
 */
export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
  const authService = inject(AuthService);

  if (!shouldAttachToken(req.url)) {
    return next(req);
  }

  if (!authService.isAuthenticated()) {
    return next(req);
  }

  return from(handleAuthRequest(req, next, authService));
};

async function handleAuthRequest(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
  authService: AuthService
): Promise<any> {
  if (!authService.hasValidAccessToken()) {
    const refreshed = await authService.refreshToken();
    if (!refreshed) {
      return lastValueFrom(next(req));
    }
  }

  const authReq = req.clone({
    setHeaders: {
      Authorization: `Bearer ${authService.getAccessToken()}`
    }
  });

  return lastValueFrom(next(authReq));
}

function shouldAttachToken(url: string): boolean {
  return url.startsWith(environment.apiBaseUrl);
}
